import React from 'react'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Toolbar } from "primereact/toolbar";

import { formatDate } from '../../js/utils'

import '../../css/candidateBoard-table.css'

const CandidateBoardTableFooter = ({ addNewCandidateBoard }) => {
  return (

     <Toolbar style={{paddingLeft: "0px"}}>
      <div className="p-toolbar-group-left">
         <Button style={{fontWeight:"bold"}} icon="pi pi-plus" label="Add Board Experience" onClick={addNewCandidateBoard} />
      </div>
    </Toolbar>

  )
}

const CandidateBoardTable = ({ canSave, addNewCandidateBoard, selectedCandidateBoard, selectCandidateBoard, candidateBoards }) => {
  let columnDefinitions = [
    { field: 'BoardName', header: 'Board Name',tabindex:"0" },
    { field: 'BoardPosition', header: 'Board Position', tabindex:"0" },
    { field: 'StartYear', header: 'Start Year', style:{width:"100px"},tabindex:"0" },
    { field: 'EndYear', header: 'End Year', style:{width:"100px"},tabindex:"0" },
    { field: '', header: 'Edit', style:{width:"150px"},tabindex:"0", body: (rowData) => {
      return <Button style={{fontWeight:"bold"}} label="Edit" onClick={selectCandidateBoard} />;
    } }
  ]
  let i=0;

  let columns = columnDefinitions.map((col, i) => {
    return <Column key={col.field} field={col.field} header={col.header} body={col.body} style={col.style} tabindex="0" />
  })
  let showAsTextOnly = canSave === false
  let footer = showAsTextOnly === false ? <CandidateBoardTableFooter addNewCandidateBoard={addNewCandidateBoard}/> : ''

  return (
    <DataTable value={candidateBoards} footer={footer} selectionMode="single" selection={selectedCandidateBoard} responsive={true} id={(i++).toString()}
     onRowClick={selectCandidateBoard} resizableColumns={false} className="candidateBoard-table" tabindex="0">
      {columns}
    </DataTable>
  )
  
}


export default CandidateBoardTable



// WEBPACK FOOTER //
// ./src/components/candidateBoard/candidateBoard-table.js